// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const PorscheTheme = props => {
	useThemeStylesheet(() => import("./porsche.lazy.scss"));
	return <>
		<ContrastColorUpdater/>
		{props.children}
	</>;
};

export default PorscheTheme;
